export default defineNuxtRouteMiddleware((to, _from) => {
        const { isAdmin } = useCredentials()
        if (!isAdmin()) return navigateTo("/dashboard")
        if (new RegExp("^/admin/?$").test(to.path)) return navigateTo("/admin/dashboard")
})
